import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
const WITHOUT = ["Información contradictoria", "Gastás de más y al pepe", "Meses de vueltas y frustración", "Riesgo de errores en el expediente", "Turnos y trámites confusos"];
const WITH = ["Sistema claro paso a paso", "Sabés en qué gastar y cuándo", "Avanzás con organización real", "Expediente ordenado y coherente", "Guía de presentación y seguimiento"];
export function Comparison() {
  return <section className="w-full bg-cream px-5 py-10" data-id="element-49" data-mp="1zw1w399w7j7m">
      <div className="mx-auto max-w-md" data-id="element-50" data-mp="1zuqtvdw3ijim">
        <h2 className="text-center font-serif text-2xl font-bold text-deep-green" data-id="element-51" data-mp="23y58q18astuh">
          El antes y el después
        </h2>

        <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-52" data-mp="28vxadmyqvubv">
          {/* Sin Kit */}
          <div className="rounded-2xl border border-red-200 bg-red-50 p-3" data-id="element-53" data-mp="9ke0951pgg0m">
            <h3 className="mb-3 text-center text-xs font-bold uppercase leading-tight text-red-800" data-id="element-54" data-mp="eiz3zeg61htt">
              Sin Kit
              <span className="block font-serif text-[13px] normal-case" data-id="element-55" data-mp="1m18wrzhzshwq">
                Ciudadanía Italiana Resuelta
              </span>
            </h3>
            <ul className="space-y-2.5" data-id="element-56" data-mp="1h7w8jqh86d4i">
              {WITHOUT.map(w => <li key={w} className="flex items-start gap-1.5" data-id="element-57" data-mp="1d8x3m5vhugd2">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-58" data-mp="18a3qwfo16tdy" />
                  <span className="text-[12px] leading-snug text-ink/75" data-id="element-59" data-mp="24xh0uzz9qmqg">
                    {w}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Con Kit */}
          <div className="rounded-2xl border border-italian-green/30 bg-italian-green/5 p-3" data-id="element-60" data-mp="1qzsh5vgxtlmz">
            <h3 className="mb-3 text-center text-xs font-bold uppercase leading-tight text-italian-green" data-id="element-61" data-mp="kjq7tenfc4vi">
              Con Kit
              <span className="block font-serif text-[13px] normal-case" data-id="element-62" data-mp="fkdlqw4dn1tz">
                Ciudadanía Italiana Resuelta
              </span>
            </h3>
            <ul className="space-y-2.5" data-id="element-63" data-mp="gzpuwy1cei5p">
              {WITH.map(w => <li key={w} className="flex items-start gap-1.5" data-id="element-64" data-mp="m0dif9qd4gv6">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-italian-green" aria-hidden="true" data-id="element-65" data-mp="81x8zb148c9c" />
                  <span className="text-[12px] leading-snug text-ink/85" data-id="element-66" data-mp="d21qn4drfd15">
                    {w}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}